import React from 'react'

let barLength = 0;

const myPalikka = document.querySelector('.hpPalkki');



function updatePalikka(palikka, value) {
    document.getElementById("hpFill").style.width = `${barLength}%`;
    document.getElementById("hpValue").textContent = `${barLength}€`;
}



function AddToValue(value){
    barLength = barLength + value;

updatePalikka(myPalikka, barLength);

}


// UpdateValue(12);






function Palkki() {

return(
    <div class='hpPalkki'>
        <span id='hpValue'></span>
        <div id='hpFill'></div>
    </div>
)
}


/*
class HpPalikka{
    constructor(element, initialValue = 0){

        this.valueElem = element.querySelector('.hpValue');
        this.fillElem = element.querySelector('.hpFill');

        this.setValue(initialValue);


    }
    setValue (newValue) {
        if (newValue < 0) {
            newValue=0;
        }
        if (newValue > 100){
            newValue=100;
        }

        this.value = newValue;
        this.update();

    }
    update () {
        const summa = this.value;

        this.fillElem.style.width = summa;
        this.valueElem.textContent = summa;
    }
}

const HpPal = document.querySelector('.hpPalkki');

new HpPalikka(HpPal, 75);
*/


export {updatePalikka, AddToValue,Palkki}
